// The Ansprechpartner card, wherever it renders — customer dashboard, public
// exposé, configurator. The gendered variants exist because the card names a
// real person; `account.advisorJobTitleHint` quotes these back to the ADVISOR
// editing their own profile.
export const ADVISOR = {
  contactPersonMale: 'Dein Ansprechpartner',
  contactPersonFemale: 'Deine Ansprechpartnerin',
  jobTitleMale: 'Sanierungsberater',
  jobTitleFemale: 'Sanierungsberaterin',
  roleMale: 'Dein persönlicher Berater',
  roleFemale: 'Deine persönliche Beraterin',
  bookAppointment: 'Termin buchen',
  noProfileForRole: 'Nur Vertriebs- und Admin-Konten haben ein Berater-Profil.',
  bookAppointmentSubline:
    'Kostenlos · unverbindlich · wir gehen deine Konfiguration gemeinsam durch',

  /** The block that closes the exposé and the results page: the same offer,
   *  worded for a visitor who has just seen a price. */
  cta: {
    eyebrow: 'Bereit für den nächsten Schritt?',
    headline: 'Lass uns über\ndein Projekt sprechen.',
    /** `advisor` is the first name to book with, or null where there is no
     *  calendar — the sentence then opens at the conversation instead. */
    body: (advisor: string | null) =>
      `${
        advisor
          ? `Buch dir direkt einen Termin im Kalender von ${advisor}.`
          : 'Sprich direkt mit uns.'
      } Wir gehen deine Konfiguration gemeinsam durch und beantworten alle offenen Fragen — kostenlos und ohne Verpflichtung.`,
    nonBinding: 'Unverbindlich',
    free: 'Kostenlos',
    personal: 'Persönlich beraten',
  },
} as const
